import { fork, all, call } from 'redux-saga/effects';
import { persistTokenRefreshTime } from '@/initializers/awsAmplify/helpers';

import { cognitoAuthHandler } from '@/domain/env/sagas';
import { restrictBrowserAccess } from '@/sagas/browserAccess';

// sagas
import router from '@/sagas/router';
import watchNavigate from '@/sagas/navigatorV6';
import auth from '@/sagas/auth';
import upload from '@/sagas/upload';
import organization from '@/sagas/organization';
import watchMessage from '@/sagas/watchMessage';
import changeLanguage from '@/sagas/changeLanguage';
import approval from '@/sagas/approval';
import changeApplication from '@/sagas/changeApplication';
import chatNotifications from '@/sagas/chatNotifications';
import globalChannel from '@/sagas/globalChannel';
import legacyChat from '@/sagas/chat';
import { watchGridPresetPersistence } from '@/domain/documents/gridPreset/sagas';

// helpers
import ROUTES_PATH from '@/router/routesPathConfig';
import { isMatchRoute } from '@/domain/router/utils';

import { cleanAuthData } from '@/sagas/idp';

const checkIDpInitiatedLoginPath = () => isMatchRoute(ROUTES_PATH.AUTH_IDP_LOGIN.absolute);

export default function* root(dispatch) {
  yield restrictBrowserAccess();

  // in case of IDp initiated login we must cleanup auth data
  // to ensure expired token wont force logout during workers start
  // also we need to remove the existing provider auth data before authorization via email link
  // because if we have an expired token in local storage, we can't login the first time
  if (checkIDpInitiatedLoginPath()) {
    yield call(cleanAuthData);
  }

  try {
    yield call(cognitoAuthHandler);
    persistTokenRefreshTime(new Date().getTime());
  } catch (error) {
    console.log('user session retrieval failed', error);
  }

  yield all([
    fork(router),
    fork(auth),
    fork(organization),
    fork(watchNavigate, dispatch),
    fork(upload, dispatch),
    fork(watchMessage, dispatch),
    fork(changeLanguage),
    fork(approval),
    fork(changeApplication),
    fork(chatNotifications, dispatch),
    fork(globalChannel, dispatch),
    fork(legacyChat, dispatch),
    fork(watchGridPresetPersistence),
  ]);
}
